import React from 'react';
function ExpandLess() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" }),
        React.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
        ' '));
}
export default ExpandLess;
